import React from "react";
import FileDownload from "@mui/icons-material/FileDownload";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {MenuItem, Tooltip, Typography} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {getResourceDownloadUrl} from "../../constants/apiEndpoints";
import {appConfigSelector} from "../../state/app-config/appConfigSelectors";
import {configSelector} from "../../state/config/configSelectors";
import {fileSave} from "../../state/file-save/fileSaveActions";
import {packageDownloaded} from "../../state/miscellaneous/miscellaneousActions";
import {nodeIdSelector} from "../../state/node/nodeSelectors";
import {getAttachmentFormat} from "../../utils/other";

const AttachmentList = ({packageId, attachments}) => {
  const dispatch = useDispatch();

  const appConfig = useSelector(appConfigSelector);
  const config = useSelector(configSelector);
  const nodeId = useSelector(nodeIdSelector);

  return (attachments || []).map((attachment, idx) => {
    const name = attachment.title ? attachment.title : attachment.url?.split("/").pop();
    const format = getAttachmentFormat(attachment.url, attachment.format);
    return (
      <MenuItem
        key={idx}
        className={`package-attachments__menu__item package-attachments__menu__item--${format.toLowerCase()}`}
        sx={{gap: "8px"}}
        tabIndex={0}
        onClick={() => {
          dispatch(packageDownloaded(format, packageId));
          if (attachment.url) {
            const target = !appConfig.newTabFormats || appConfig.newTabFormats.includes(format) ? "_blank" : "_self";
            window.open(attachment.url, target);
          } else {
            dispatch(
              fileSave(
                getResourceDownloadUrl(nodeId, packageId, attachment.id),
                {name: name, extension: format},
                config.baseURL
              )
            );
          }
        }}
      >
        {attachment.format === "html" ? (
          <OpenInNewIcon className={"package-attachments__menu__item__icon"} />
        ) : (
          <FileDownload className={"package-attachments__menu__item__icon"} />
        )}
        <Tooltip title={`${name}.${format}`} placement="top">
          <Typography noWrap>{`${name}.${format}`}</Typography>
        </Tooltip>
      </MenuItem>
    );
  });
};

export default AttachmentList;
